module.exports = __webpack_public_path__ + "static/media/pup_greyedout_withquestionmark.1d5e5faa.png";